import React, { useEffect, useRef } from "react";
import { ITkExpandableListProps } from "../../../type/componentsType/TkExpandableList";
import { Box } from "@mui/material";
import TkTitle from "../TkTitle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import "./_style.scss";

/**
 * TkExpandableListコンポーネントは、展開可能なリストを表示するためのコンポーネントです。
 *
 * @param {ITkExpandableListProps} props - コンポーネントのプロパティ
 * @param {React.ReactNode} props.children - 子要素
 * @param {string} props.title - タイトル
 * @returns {React.ReactElement} TkExpandableListコンポーネント
 */
const TkExpandableList: React.FC<ITkExpandableListProps> = (props) => {
  const { children, title, defOpen = false } = props;

  const [bordHeight, setBordHeight] = React.useState("");
  const [bordOpen, setBordOpen] = React.useState(false);

  const boxRef = useRef<HTMLDivElement>(null);

  useEffect(
    () => {
      const ref = boxRef.current;
      if (ref) {
        setBordHeight(`${ref.scrollHeight}px`);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [children]
  );

  useEffect(() => {
    setBordOpen(defOpen);
  }, [defOpen]);

  return (
    <Box className="tkExpandableList">
      <Box onClick={() => setBordOpen(!bordOpen)} className="topBox">
        <TkTitle className="title" size="medium">
          ■ {title}
        </TkTitle>
        {!bordOpen ? (
          <AddCircleOutlineIcon className="addicon" />
        ) : (
          <RemoveCircleOutlineIcon className="addicon" />
        )}
      </Box>

      <Box
        ref={boxRef}
        style={{ "--maxHeight": `${bordHeight}` } as React.CSSProperties}
        className={`listBox ${bordOpen ? "keepMaxHeight" : ""}`}
      >
        {children}
      </Box>
    </Box>
  );
};

export default TkExpandableList;
